import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const text = `
Hey Baba Industries! I have a requirement.

Name: ${formData.name}
Email: ${formData.email}
Message: ${formData.message}
    `.trim();

    const encodedText = encodeURIComponent(text);
    const waNumber = "9415481386";
    const url = `https://wa.me/${waNumber}?text=${encodedText}`;

    window.open(url, "_blank");
    setLoading(false);
  };

  return (
    <div
      className="py-5"
      style={{
        backgroundImage: "https://plus.unsplash.com/premium_photo-1661373713949-510c1f0af83f?q=80&w=1471&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container bg-white rounded shadow p-4">
        <h2 className="fw-bold text-center mb-4">Contact Information</h2>

        {/* Contact Info */}
        <div className="row text-center mb-5">
          <div className="col-md-4">
            <h5 className="d-flex justify-content-center align-items-center gap-2">
              <FaMapMarkerAlt className="text-primary" /> Address
            </h5>
            <p>
              Baba Industries Village Kaithara, Tehsil-Bhognipur,
              Kanpur Dehat (U.P.)-209112
            </p>
          </div>

          <div className="col-md-4">
            <h5 className="d-flex justify-content-center align-items-center gap-2">
              <FaPhoneAlt className="text-primary" /> Phone
            </h5>
            <p>
              +91 9415481386 <br /> +91 8318992308
            </p>
          </div>

          <div className="col-md-4">
            <h5 className="d-flex justify-content-center align-items-center gap-2">
              <FaEnvelope className="text-primary" /> Email
            </h5>
            <p>babaindustries69@gmail.com</p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  name="message"
                  className="form-control"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Google Map */}
          <div className="col-12 mt-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3580.7547460380297!2d79.80409167541416!3d26.17211567709639!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDEwJzE5LjYiTiA3OcKwNDgnMjQuMCJF!5e0!3m2!1sen!2sin!4v1768642090551!5m2!1sen!2sin"
              height="450"
              className="w-100 border-0"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
